import "./timeline.css";
import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const Timeline = ({
  timelineName,
  name,
  provider,
  description,
  certificateLink,
  link,
  timeline,
}) => {
  const [, setNumPages] = useState(null);
  const [pageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  return (
    <div className={`${timelineName} timeline`}>
      <p>{timeline}</p>
      <div
        className={
          timelineName === "certification"
            ? "d-flex justify-content-between align-items-start"
            : null
        }
      >
        <div className="timeline-content d-flex flex-column justify-content-between">
          <ul>
            <li style={{ textTransform: "capitalize" }}>
              <strong>{timelineName} Name</strong>:&nbsp;&nbsp;{name}
            </li>
            <li style={{ textTransform: "capitalize" }}>
              <strong>{timelineName} Provider</strong>:&nbsp;&nbsp;{provider}
            </li>
          </ul>

          <p
            style={
              timelineName === "certification" ? { display: "none" } : null
            }
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          ></p>
          <div className="certificate-buttons-div">
            <a className="button" href={link} target="_blank" rel="noreferrer">
              Visit Website
            </a>
            <a
              style={timelineName === "courses" ? { display: "none" } : null}
              className="button"
              href={certificateLink}
              download
            >
              Download Credential
            </a>
          </div>
        </div>
        <div
          className="certificate"
          style={timelineName === "courses" ? { display: "none" } : null}
        >
          <Document
            file={certificateLink}
            onLoadSuccess={onDocumentLoadSuccess}
          >
            <Page pageNumber={pageNumber} />
          </Document>
        </div>
      </div>
    </div>
  );
};

export default Timeline;
